import { AfterContentInit, AfterViewInit, Directive, ElementRef, Input } from '@angular/core';


@Directive({
    selector: '[autofocus]',
    standalone: false
})

  export class AutoFocusDirective implements AfterContentInit  {

    @Input('autofocus') options: any;

    constructor(private elem: ElementRef) {}

    public ngAfterContentInit() {
        if (this.options.isMobile) {
            // console.log('ngAfterContentInit: autofocus - isMobile');
            return;
        } else {
            setTimeout(() => {
                this.elem.nativeElement.focus();
                // console.log('ngAfterContentInit: autofocus');
            }, 500);
        }
    }
  }